import { HttpInterceptorFn } from '@angular/common/http';
import { NsideIdentityService } from '../shared/services/auth/nSideIdentityService';
import { inject } from '@angular/core';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const nSideIdentityService: NsideIdentityService = inject(NsideIdentityService);
  let token = '';

  nSideIdentityService.getAccessToken()?.subscribe((accessToken) => {
    if (accessToken) {
      token = accessToken;
    }
  });

  const modifiedReq = req.clone({
    setHeaders: {
        Authorization: `Bearer ${token}`
    }
  });

  return next(modifiedReq);
};

